import React, { useRef, useState } from 'react'
import { DownArrowIcon } from '../icons'
import LinksDropdownMenu from '../linksPopupMenu/LinksPopupMenu'
import Image from 'next/image'
import { AnimatePresence, motion } from 'framer-motion'

const NavDropdown = ({ route }) => {
  const { name, subLinks } = route
  const [showDropdown, setShowDropdown] = useState(false)
  const parentRef = useRef()
  return (
    <>
      <div
        onClick={() => setShowDropdown((prev) => !prev)}
        className='nav-dropdown'
        ref={parentRef}
      >
        {name}
        <Image
          width={12}
          height={12}
          src='https://storage.googleapis.com/rolzo-static-bucket/icons/icon-arrow-down.png'
          alt='Explore rolzo services'
        />
        <AnimatePresence mode='wait'>
          {showDropdown && (
            <LinksDropdownMenu
              parentRef={parentRef}
              subLinks={subLinks}
              setShowDropdown={setShowDropdown}
            />
          )}
        </AnimatePresence>
      </div>
    </>
  )
}

export default NavDropdown
